//Built-in libraries
import { useState } from 'react';

//Custom components
import Table from '../../../UI/Table';

//Services

//Assets and Miscellaneous

const ImpactByCounty = () => {
  const [perPage, setPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);

  const data: any = [
    {
      countyCode: '1',
      countyName: 'Allegany',
      totalGrants: '$ 550,000',
      totalProjects: '8',
    },
    {
      countyCode: '2',
      countyName: 'Anne Arundel',
      totalGrants: '$ 2,727,273',
      totalProjects: '10',
    },
    {
      countyCode: '3',
      countyName: 'Baltimore City',
      totalGrants: '$ 132,500',
      totalProjects: '5',
    },
    {
      countyCode: '4',
      countyName: 'Baltimore County',
      totalGrants: '$ 3,929,000',
      totalProjects: '10',
    },
    {
      countyCode: '5',
      countyName: 'Calvert',
      totalGrants: '$ 119,000',
      totalProjects: '8',
    },
    {
      countyCode: '6',
      countyName: 'Caroline',
      totalGrants: '$ 139,500',
      totalProjects: '15',
    },
  ];

  const nextPageHandler = () => {
    setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
  };

  const previousPageHandler = () => {
    setPage((prevState) => (prevState > 1 ? page - 1 : 1));
  };

  const tableColumns = [
    {
      id: 'countyCode',
      Header: 'County Code',
      accessor: 'countyCode',
      Cell: (row: any) => {
        return row.value;
      },
    },
    {
      id: 'countyName',
      Header: () => <div className="text-center">County Name</div>,
      accessor: 'countyName',
      Cell: (row: any) => (
        <div className="text-center">
          <span>{row.value}</span>
        </div>
      ),
    },
    {
      id: 'totalGrants',
      Header: () => <div className="text-center">Total Grants</div>,
      accessor: 'totalGrants',
      Cell: (row: any) => (
        <div className="text-center">
          <span>{row.value}</span>
        </div>
      ),
    },
    {
      id: 'totalProjects',
      Header: () => <div className="text-center">Total Projects</div>,
      accessor: 'totalProjects',
      Cell: (row: any) => (
        <div className="text-center">
          <span>{row.value}</span>
        </div>
      ),
    },
  ];

  const tablePagination = {
    page: page,
    pageSize: perPage,
    pageCount: totalPage,
    currentPage: page,
    setPageSize: (v: number) => setPerPage(v),
    nextPage: nextPageHandler,
    previousPage: previousPageHandler,
  };

  return (
    <>
      <div className="h-full w-full">
        <div className="flex flex-row  bg-white justify-start items-center rounded-t-md py-4">
          <h3 className="font-bold text-bold border-l-4 p-4 border-green-500 capitalize">
            Impact By County
          </h3>

          <div className="pr-2 text-neutralColor-light cursor-pointer hover:text-neutralColor-medium transition duration-300 ease-in-out"></div>
        </div>
        <div className="h-96 border rounded-b-md w-full">
          <Table
            cols={tableColumns}
            tableData={data}
            pagination={tablePagination}
          />
        </div>
      </div>
    </>
  );
};

export default ImpactByCounty;
